import styled from 'styled-components';

const Card = styled.div`
    box-shadow: 0px 4px 12px #03326914;
    border-radius: 8px;
    overflow: hidden;
    background-color: ${({ backgroundColor }) =>
        backgroundColor ? backgroundColor : 'transparent'};
    padding: ${({ padding }) => (padding ? padding : '')};
    margin: ${({ margin }) => (margin ? margin : '')};
`;

export default Card;
